module.exports = __webpack_public_path__ + "img/people-46-min.33bceca3.png";